import Vue from 'vue'
import Router from 'vue-router'
import Restaurants from '@/components/Restaurants/Restaurants'
import People from '@/components/Drivers/Drivers'
import List from '@/components/Drivers/ListDriverName'
import Options from '@/components/Options/Options'
import NewsFeed from '@/components/NewsFeed/NewsFeed'
import Registration from '@/components/Auth/Registration'
import LogIn from '@/components/Auth/LogIn'
import Home from '@/components/Auth/Home'
import Areas from '@/components/Areas/Areas'
import Schedule from '@/components/Schedule/Schedule'
import ScheduleRestaurant from '@/components/ScheduleRestaurant/ScheduleRestaurant'
import Timesheet from '@/components/Timesheet/Timesheet'
import TimesheetRestaurant from '@/components/TimesheetRestaurant/TimesheetRestaurant'
import Invoices from '@/components/Invoices/Invoices'
import InvoicesRestaurant from '@/components/InvoicesRestaurant/InvoicesRestaurant'
import Users from '@/components/Users/Users'
import AuthGuard  from './auth-guard'
import Reporting from '@/components/Reporting/Reporting'
import RestaurantGroup from '@/components/DriverShare/RestaurantGroup/RestaurantGroup'
import DriverShareSchedule from '../components/DriverShare/Schedule/DriverShareSchedule.vue'
import DriverShareTimesheet from '../components/DriverShare/Timesheet/DriverShareTimesheet.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '',
            beforeEnter: AuthGuard
        },
        {
            path: '/home',
            props: true,
            name: 'Home',
            component: Home,
            beforeEnter: AuthGuard
        },
        {
            path: '/login',
            props: true,
            name: 'LogIn',
            component: LogIn,
        },
        {
            path: '/registration',
            props: true,
            name: 'Registration',
            component: Registration,
        },
        {
            path: '/newsfeed',
            props: true,
            name: 'NewsFeed',
            component: NewsFeed,
            beforeEnter: AuthGuard
        },
        {
            path: '/schedule',
            props: true,
            name: 'Schedule',
            component: Schedule,
            beforeEnter: AuthGuard
        },
        {
            path: '/schedulerestaurant',
            props: true,
            name: 'ScheduleRestaurant',
            component: ScheduleRestaurant,
            beforeEnter: AuthGuard
        },
        {
            path: '/timesheet',
            props: true,
            name: 'Timesheet',
            component: Timesheet,
            beforeEnter: AuthGuard
        },
        {
            path: '/timesheetrestaurant',
            props: true,
            name: 'TimesheetRestaurant',
            component: TimesheetRestaurant,
            beforeEnter: AuthGuard
        },
        {
            path: '/restaurants',
            props: true,
            name: 'Restaurants',
            component: Restaurants,
            beforeEnter: AuthGuard
        },
        {
            path: '/drivers',
            props: true,
            name: 'People',
            component: People,
            beforeEnter: AuthGuard
        },
        {
            path: '/drivers/:id',
            props: true,
            name: 'People2',
            component: People,
            beforeEnter: AuthGuard
        },
        {
            path: '/drivers/:first_name',
            props: true,
            name: 'People3',
            component: List,
            beforeEnter: AuthGuard
        },
        {
            path: '/areas',
            props: true,
            name: 'Areas',
            component: Areas,
            beforeEnter: AuthGuard
        },
        {
            path: '/options',
            props: true,
            name: 'Options',
            component: Options,
            beforeEnter: AuthGuard
        },
        {
            path: '/invoices',
            props: true,
            name: 'Invoices',
            component: Invoices,
            beforeEnter: AuthGuard
        },
        {
            path: '/invoicesrestaurant',
            props: true,
            name: 'InvoicesRestaurant',
            component: InvoicesRestaurant,
            beforeEnter: AuthGuard
        },
        {
            path: '/users',
            props: true,
            name: 'users',
            component: Users,
            beforeEnter: AuthGuard
        },
        {
            path: '/reporting',
            props: true,
            name: 'reporting',
            component: Reporting,
            beforeEnter: AuthGuard
        },
        {
            path: '/restaurant-group',
            props: true,
            name: 'RestaurantGroup',
            component: RestaurantGroup,
            beforeEnter: AuthGuard
        },
        {
            path: '/drivershare-schedule',
            props: true,
            name: 'DriverShareSchedule',
            component: DriverShareSchedule,
            beforeEnter: AuthGuard
        },
        {
            path: '/drivershare-timesheet',
            props: true,
            name: 'DriverShareTimesheet',
            component: DriverShareTimesheet,
            beforeEnter: AuthGuard
        },

    ],
    scrollBehavior(){
        return{x:0,y:0}
    }
})